/**
 * card-product-custom.js
 * 기존 snippets/card-product.liquid 하단 <script>를 분리한 파일.
 * - 카드마다 스크립트가 복제되어 카드 수만큼 실행되던 문제 해결 (페이지당 1번 실행)
 * - ipinfo.io(요청 한도 초과로 429) 대신 Shopify 자체 국가 감지 사용 + 세션 캐시
 * layout/theme.liquid 의 </body> 바로 위에서 jQuery 이후에 불러온다.
 */
(function ($) {
  if (!$ || window.__cardProductCustomInit) return;
  window.__cardProductCustomInit = true;

  // 방문자 국가 코드 (예: 'US'). 한 번만 요청하고 sessionStorage에 저장
  window.getVisitorCountry = window.getVisitorCountry || (function () {
    var pending;
    return function () {
      if (pending) return pending;
      var cached = null;
      try { cached = sessionStorage.getItem('visitor_country'); } catch (e) {}
      if (cached) return (pending = Promise.resolve(cached));

      pending = fetch('/browsing_context_suggestions.json?country[enabled]=true')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
          if (c) {
            try { sessionStorage.setItem('visitor_country', c); } catch (e) {}
          }
          return c || null;
        })
        .catch(function () { return null; });
      return pending;
    };
  })();

  $(document).ready(function () {
    // 단품이지만 세트(is-set-item)로 함께 분류할 상품 ID
    const forceSetIds = [
      '10316141855010',
      '10089482289442',
      '10316179865890'
    ];

    // .card__heading의 id가 "-상품ID"로 끝나는지 확인 (부분 일치 오탐 방지)
    function isForcedSet($item) {
      return forceSetIds.some(function (id) {
        return $item.find('.card__heading[id$="-' + id + '"]').length > 0;
      });
    }

    // 배지 추가
    $('#product-grid .grid__item').each(function () {
      if ($(this).find('.thumb_set_badge_wrap').length) {
        var originPrice = $(this).find('#orign_p').attr('rel');
        var rate = $(this).find('#real_p').attr('rel');
        var savePrice = Math.floor(100 - (rate * 100 / originPrice));
        $(this).find('.badge--set strong b').text(savePrice);
      }

      let vari = $(this).find('#orign_p').attr('data-vari');
      if (vari !== 'set' && !isForcedSet($(this))) {
        $(this).addClass('is-single-item');
      } else {
        $(this).addClass('is-set-item');
        $(this).find('.card .card__inner .card__media .thumb_set_badge_wrap .badge--set span i').text('(Bundle Deals)');
      }
    });

    /* 구독없는 제품들 한정 가격 노출*/
    const productIds = [
      '9968787030306',
      '9968784998690',
      '10092010406178'
    ];

    productIds.forEach(pid => {
      const headings = document.querySelectorAll(`[id*="product-grid-${pid}"]`);

      headings.forEach(heading => {
        const card = heading.closest('.card__content');
        const priceEl = card?.querySelector('.price--on-sale');

        if (priceEl) {
          priceEl.style.display = 'block';

          const priceSale = priceEl.querySelector('.price__sale');

          if (priceSale) {
            priceSale.style.display = 'flex';
            priceSale.style.flexDirection = 'row-reverse';
          }

          // 가격 영역 클릭 시 Quick Add 버튼 클릭
          priceEl.addEventListener('click', function (e) {
            e.preventDefault();

            const quickAddBtn = card?.querySelector('.quick-add.no-js-hidden button');

            if (quickAddBtn) {
              quickAddBtn.click();
            }
          });
        }
      });
    });
    /* [E] gift 박스들 한정 가격 노출*/

    // 사용자 위치 확인 (ipinfo.io → Shopify 국가 감지로 변경)
    window.getVisitorCountry().then(function (country) {
      if (country === 'US') {
        // 이너케어젤, 퍼퓸미스트 한정 subscription 문구 추가
        let iniGel = $('.product-grid-container .grid__item .card__content .card__heading a[href="/products/intimate-care-gel-for-women"]')
                      .parent().siblings('.card-information').find('.price--on-sale').first();
        let iniSpray = $('.product-grid-container .grid__item .card__content .card__heading a[href="/products/feminine-intimate-deodorant-spray"]')
                      .parent().siblings('.card-information').find('.price--on-sale').first();
        let mainIniGel = $('.main_pd .grid__item .card__content .card__heading a[href="/products/intimate-care-gel-for-women"]')
                      .parent().siblings('.card-information').find('.price--on-sale').first();
        let mainIniSpray = $('.main_pd .grid__item .card__content .card__heading a[href="/products/feminine-intimate-deodorant-spray"]')
                      .parent().siblings('.card-information').find('.price--on-sale').first();

        // 기존의 subscription 요소를 제거한 후 새로 추가
        iniGel.find('.subscription').remove();
        iniGel.append('<span class="subscription">$32.39/mo with subscription</span>');
        iniSpray.find('.subscription').remove();
        iniSpray.append('<span class="subscription">$26.99/mo with subscription</span>');

        mainIniGel.find('.subscription').remove();
        mainIniGel.append('<span class="subscription">$32.39/mo with subscription</span>');
        mainIniSpray.find('.subscription').remove();
        mainIniSpray.append('<span class="subscription">$26.99/mo with subscription</span>');
      }
    });
  });
})(window.jQuery);